import { useEffect, useState } from 'react';

import NetworkAppsService from 'services/network-apps/NetworkApps';
import usePlanFilters from 'hooks/usePlanFilters';
import useStateAsync from 'hooks/useStateAsync';

const useBulkSelectPlan = ({ preselect }) => {
  const [isNewData, setIsNewData] = useState(true);

  const planFilters = usePlanFilters({
    initialFilters: {
      limit: 10,
      offset: 0,
      ...(preselect ? preselect() : {}),
    },
    onSetFilter: (filterName, values, setFilters) => {
      const newFilters = { offset: 0 };
      setFilters((prev) => ({ ...prev, [filterName]: values, ...newFilters }));
      setIsNewData(true);
    },
  });

  const service = useStateAsync(NetworkAppsService.getPlansList, { immediate: false });

  useEffect(() => {
    service.execute({
      ...planFilters.selected,
      sort: 'name:asc',
    });
  }, [planFilters.selected]);

  return {
    isNewData,
    setIsNewData,
    ...planFilters,
    ...service,
  };
};

export default useBulkSelectPlan;
